module.exports = __webpack_public_path__ + "img/capa-ebook.eb4c213a.jpg";